/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum FILTER_ATTRS_LIST {
  TYPE = "type",
  LEFT = "left",
  RIGHT = "right",
  CLAUSE = "clause",
  NAME = "name",
  FIELD = "field",
  VALUES = "values",
}
